export const TENDER_STATUSES = {
  DRAFT: 'draft',
  ACTIVE_TENDERING: 'active.tendering',
  ACTIVE_QUALIFICATION: 'active.qualification',
  ACTIVE_AWARDED: 'active.awarded',
  COMPLETE: 'complete',
  CANCELED: 'canceled',
}
